"use strict";

exports.__esModule = true;
exports.useMergedRef = useMergedRef;

var _react = require("react");

function useMergedRef(refs) {
  var mergedRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    refs.forEach(function (ref) {
      if (!ref) return;
      if (typeof ref === 'function') ref(mergedRef.current);else ref.current = mergedRef.current;
    });
  }, refs);
  return mergedRef;
}